import { render, staticRenderFns } from "./InvestorInformation.vue?vue&type=template&id=0dd4bce7&scoped=true"
import script from "./InvestorInformation.vue?vue&type=script&lang=js"
export * from "./InvestorInformation.vue?vue&type=script&lang=js"
import style0 from "./InvestorInformation.vue?vue&type=style&index=0&id=0dd4bce7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4bce7",
  null
  
)

export default component.exports